import { styled } from '@mui/material/styles';
import { ListItem as MUIListItem, ListItemProps } from '@mui/material';
import React from 'react';

export const ListItem = styled((props: ListItemProps) => (
  <MUIListItem disablePadding={true} disableGutters={false} {...props} />
))(() => ({
  display: 'list-item',
  // padding: 0,
  // margin: 0,
}));
